/** Control height: sm = 32px, md = 38px (default), lg = 46px. */
export type ShSize = 'sm' | 'md' | 'lg';

/** One severity vocabulary for every component that has a colour role. */
export type ShSeverity =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'neutral';

/** PrimeNG's `size` (buttons, inputs, selects): the default size is `undefined`. */
export function primeSize(size: ShSize): 'small' | 'large' | undefined {
  return size === 'sm' ? 'small' : size === 'lg' ? 'large' : undefined;
}

export type PrimeSeverity =
  | 'success'
  | 'info'
  | 'warn'
  | 'danger'
  | 'help'
  | 'primary'
  | 'secondary'
  | 'contrast'
  | undefined;

/** Maps SHIPM8 severities to PrimeNG button severities. */
export function primeSeverity(severity: ShSeverity): PrimeSeverity {
  switch (severity) {
    case 'primary':
      return undefined;
    case 'warning':
      return 'warn';
    case 'neutral':
      return 'contrast';
    default:
      return severity;
  }
}

/** Reads a (dotted) field from an object; primitives are returned as they are. */
export function resolveField(item: unknown, path: string): unknown {
  if (item === null || item === undefined) return undefined;
  if (typeof item !== 'object') return item;
  return path
    .split('.')
    .reduce<unknown>(
      (value, key) =>
        value === null || value === undefined
          ? undefined
          : (value as Record<string, unknown>)[key],
      item
    );
}
